import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import {
    ColumnConfigMappingType, SkyNetDataGridFilterType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    FilterType,
} from 'app/enums/common.enums'

type AdditionalFeesTable = Contact & {
    additionalFeesNumber: string,
    additionalFeesStatus: string,
    validFrom: string,
    validTo: string,
    changedOn: string,
    changedBy: string,
}

// TODO-JM: in main tables we use SkyNetTableField but here ColumnConfigMappingType is used.
// we need to create one type and converter with existing configs
// that will fix TODO-DK columns type comments - IP-22610
const config: ColumnConfigMappingType<AdditionalFeesTable>[] = [
    {
        name: 'additionalFeesNumber',
        labelKey: 'AdditionalFees.additionalFeesNumber',
    },
    {
        name: 'additionalFeesStatus',
        labelKey: 'AdditionalFees.additionalFeesStatus',
        filterType: FilterType.Array,
        componentName: 'AdditionalFeesStatusEnriched',
    },
    {
        name: 'validFrom',
        componentName: 'DateTimeCell',
        labelKey: 'AdditionalFees.validFrom',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
    },
    {
        name: 'validTo',
        componentName: 'LaneDateEnriched',
        labelKey: 'AdditionalFees.validTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
    },
    {
        name: 'changedOn',
        componentName: 'DateTimeCell',
        labelKey: 'AccountLane.changedOn',
    },
    {
        name: 'changedBy',
        labelKey: 'LaneGroup.changedBy',
    },
]

export default config
